import { render, staticRenderFns } from "./HomeFunction.vue?vue&type=template&id=ded53ad4&scoped=true"
import script from "./HomeFunction.vue?vue&type=script&lang=js"
export * from "./HomeFunction.vue?vue&type=script&lang=js"
import style0 from "./HomeFunction.vue?vue&type=style&index=0&id=ded53ad4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded53ad4",
  null
  
)

export default component.exports